import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Hachapury = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/makmenu' name='Хачапурi'/>
            <main className={s.main}>
                <Product name="Хачапурі м'ясне" price='150 грн.' weight='550г.' info1='фарш свинний, цибуля, олія, томатна паста, французька гірчиця, соєвий соус, сосиски єгерські, моцарела, зелень, соус Тереякі'/>
                <Product name="Хачапурі по аджарськи" price='130 грн.' weight='490г.' info1='моцарела, бринза, масло, яйце'/>
                <Product name="Хачапурі по мегрельськи" price='120 грн.' weight='455г.' info1='моцарела, бринза, масло'/>
                <Product name="Хачапурі з куркою" price='150 грн.' weight='535г.' info1='куряче філе, моцарела, бринза, масло'/>
            </main>
        </div>
    )
}

export default Hachapury;